import { useEffect } from 'react';
import Modal from 'components/Shared/Modal';
import styles from './styles.scss';
import { useToggle } from 'hooks';
import { useDispatch, useSelector } from 'react-redux';
import { getSalesTaker, getSalesTakerQuery, getSiteMode } from 'components/SiteMode/selector';
import { rm } from 'utils';
import { clearSalesTakerInQueryString } from './actions';
import { SiteMode } from 'models/SiteMode';
import Button from 'components/Shared/Button';

const getShouldDisplaySalesTaker = ({ siteMode }: { siteMode: SiteMode }) => {
  return siteMode === SiteMode.Private || siteMode === SiteMode.Company;
};

export const SalesTakerModal = () => {
  const siteMode = useSelector(getSiteMode);
  const isSalesTaker = !!useSelector(getSalesTakerQuery);
  const salesTaker = useSelector(getSalesTaker);
  const dispatch = useDispatch();
  const shouldDisplaySalesTaker = getShouldDisplaySalesTaker({ siteMode });

  const [show, setShow] = useToggle(false);
  const close = () => setShow(false);

  const handleClose = () => {
    close();
  };

  useEffect(() => {
    if (salesTaker && isSalesTaker && shouldDisplaySalesTaker) {
      setShow(true);
      dispatch(clearSalesTakerInQueryString());
    }
  }, [salesTaker, isSalesTaker, shouldDisplaySalesTaker, dispatch, setShow]);

  return (
    <Modal onClose={handleClose} show={show}>
      <h3 className={styles.welcome}>{rm('salestaker_cart', salesTaker)}</h3>
      <Button onClick={close}>{rm('shared_button_close')}</Button>
    </Modal>
  );
};
